module.exports = __webpack_public_path__ + "img/OiranDreamXmas.fd4a409b.png";